import { ThunkAction } from "redux-thunk";
import { RootState } from "../../store";
import { AnyAction } from "redux";
import FillableFormsService from "../../services/administration/fillableForms";
import {
  setErrorMessage,
  setSuccessMessage,
} from "../actionsCreators/messageActions";
import {
  DELETE_USER_SUCCESS,
  FILE_WAS_SENT,
  FILLABLE_FORM_WAS_CREATED,
  PAYOFF_WAS_SENT,
  UPDATE_RECORD_SUCCESS,
} from "../../lib/constants";
import { IFillableFormRequest } from "../../pages/Administration/FillableForms/types";
import {
  ISendFormForReviewRequest,
  ISendPayoffQuotesForReviewRequest,
} from "../../pages/RequestsAndForms/types";
import PortalRequestsAndFormsService from "../../services/portalRequestsAndFormsService";

export const deleteFillableForm =
  (id: string): ThunkAction<void, RootState, unknown, AnyAction> =>
  async (dispatch) => {
    try {
      const res = await FillableFormsService.remove(id);

      dispatch(setSuccessMessage(DELETE_USER_SUCCESS));

      return await Promise.resolve(res);
    } catch (error: any) {
      dispatch(setErrorMessage(error.response.data.title, true));

      return await Promise.reject(error);
    }
  };

export const createFillableForm =
  (
    entry: IFillableFormRequest,
  ): ThunkAction<void, RootState, unknown, AnyAction> =>
  async (dispatch) => {
    try {
      const res = await FillableFormsService.create(entry);

      dispatch(setSuccessMessage(FILLABLE_FORM_WAS_CREATED));

      return await Promise.resolve(res);
    } catch (error: any) {
      dispatch(setErrorMessage(error.response.data.title, true));

      return await Promise.reject(error);
    }
  };

export const sendFormForReview =
  (
    contractNumber: string,
    req: ISendFormForReviewRequest,
  ): ThunkAction<void, RootState, unknown, AnyAction> =>
  async (dispatch) => {
    try {
      const res = await PortalRequestsAndFormsService.sendForm(
        contractNumber,
        req,
      );

      dispatch(setSuccessMessage(FILE_WAS_SENT));

      return await Promise.resolve(res);
    } catch (error: any) {
      dispatch(setErrorMessage(error.response.data.title, true));

      return await Promise.reject(error);
    }
  };

export const sendPayoffQuotesForReview =
  (
    contractNumber: string,
    req: ISendPayoffQuotesForReviewRequest,
  ): ThunkAction<void, RootState, unknown, AnyAction> =>
  async (dispatch) => {
    try {
      const res = await PortalRequestsAndFormsService.sendPayoffQuotes(
        contractNumber,
        req,
      );

      dispatch(setSuccessMessage(PAYOFF_WAS_SENT));

      return await Promise.resolve(res);
    } catch (error: any) {
      dispatch(setErrorMessage(error.response.data.title, true));

      return await Promise.reject(error);
    }
  };

export const editFillableForm =
  (
    entry: IFillableFormRequest,
    id: string,
  ): ThunkAction<void, RootState, unknown, AnyAction> =>
  async (dispatch) => {
    try {
      const res = await FillableFormsService.edit(entry, id);

      dispatch(setSuccessMessage(UPDATE_RECORD_SUCCESS));

      return await Promise.resolve(res);
    } catch (error: any) {
      dispatch(setErrorMessage(error.response.data.title, true));

      return await Promise.reject(error);
    }
  };
